module.exports = __webpack_public_path__ + "img/paper.1b96b6fb.svg";